<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('pickupCardCreation.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('pickupCardCreation.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex">
          <ts-button
            color="info"
            outline
            @click="$router.push({ name: 'pickup-card-creation-create' })"
            >{{ $t('add_new') }}</ts-button
          >
          <div
            class="ml-2 ts-rounded ts-border ts-px-2 ts-whitespace-no-wrap mr-2"
            style="width: 140px"
          >
            <div class="radio radio-css radio-inline">
              <input v-model="side" type="radio" id="front" :value="'front'" />
              <label for="front">{{ $t('pickupCardCreation.front') }}</label>
            </div>
            <div class="radio radio-css radio-inline">
              <input v-model="side" type="radio" id="back" :value="'back'" />
              <label for="back">{{ $t('pickupCardCreation.back') }}</label>
            </div>
            <!-- Old Preview Card  -->
            <!-- <ts-button
              v-if="true"
              class="btn-sm ml-2 mr-2"
              :disabled="!checkedGuardian.length > 0"
              outline
              color="primary"
              @click.prevent="
                side == 'back' ? (visibleCard = true) : previewCard('simple')
              "
            >
              {{ $t('pickupCardCreation.previewCard') }}
            </ts-button> -->
          </div>
          <!-- New Preview Card -->
          <div class="ts-mr-2" v-if="true">
            <b-dropdown
              dropdown
              :text="
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.previewCard'
                )
              "
              variant="primary"
            >
              <b-dropdown-item
                :disabled="!checkedGuardian.length > 0"
                href="#"
                @click="previewCard('L805')"
              >
                <i class="fas fa-print"></i>
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.simplePrinter'
                  )
                }}
              </b-dropdown-item>
              <b-dropdown-item
                :disabled="!checkedGuardian.length > 0"
                href="#"
                @click="previewCard('L8050')"
              >
                <i class="fas fa-print"></i>
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.proPrinter'
                  )
                }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="ts-flex-grow"></div>
          <div class="mr-2">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px"
            />
          </div>
          <b-dropdown
            dropdown
            variant="outline-default"
            :waiting="exporting"
            no-caret
            right
          >
            <template v-slot:button-content>
              <i class="fas fa-align-justify"></i>
            </template>
            <b-dropdown-item
              @click="
                $router.push({ name: 'pickup-card-creation-card-by-class' })
              "
            >
              <i class="fas fa-address-card"></i>
              {{ $t('pickupCardCreation.cardByClass') }}
            </b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="() => (visible = true)">
              <i class="fas fa-filter"></i>
              {{ $t('pickupcardcreation.filter') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'student.full_name_en'
          }"
          :showCheckbox="true"
          @check-items="checkItem"
        >
          <template v-slot="{ record }">
            <td>{{ record.branch ? record.branch.branch_name_en : '' }}</td>
            <td class="with-img" width="2%">
              <img
                class="height-30 ts-rounded"
                v-lazy="{
                  src: guardianPhoto(record),
                  error: onError(record),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }"
              />
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.card_number }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.guardian }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.guardian_kh }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.relationship }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.contact_no }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.issued_date }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.expiry_date }}
            </td>
            <td class="ts-text-center">
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_increase')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="increase(record)"
              >
                <a
                  href="#"
                  class="ts-border ts-rounded-full ts-px-2 ts-h-1 ts-bg-teal-500 ts-text-white"
                >
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <span v-else>
                    {{ record.printer_counter ? record.printer_counter : 0 }}
                  </span>
                </a>
              </a-popconfirm>
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('delete')"
                class="text-danger mr-1"
                @click.prevent="showDeleteForm(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
              <b-dropdown
                size="xs"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                right
                v-tooltip="$t('pickupCardCreation.card')"
              >
                <template slot="button-content">
                  <i class="fas fa-id-card"></i>
                </template>
                <b-dropdown-item @click="card(record, 'front')">
                  <i class="fas fa-address-card"></i>
                  {{ $t('pickupCardCreation.frontCard') }}
                </b-dropdown-item>
                <b-dropdown-item @click="card(record, 'back')">
                  <i class="far fa-credit-card"></i>
                  {{ $t('pickupCardCreation.backCard') }}
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-drawer
        :title="$t('invoice.filter')"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        width="300px"
      >
        <div class="row">
          <legend class="text-black ts-text-sm">
            {{ $t('studentprofile.printCard') }}
          </legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input
                v-model="is_print_card"
                type="radio"
                id="printedCard"
                :value="1"
              />
              <label for="printedCard">
                {{ $t('studentprofile.printedCard') }}
              </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input
                v-model="is_print_card"
                type="radio"
                id="no_print_card"
                :value="2"
              />
              <label for="no_print_card"
                >{{ $t('studentprofile.notYetPrintCard') }}
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="ts-text-xs">
                {{ $t('studentprofile.branch') }}
              </label>
              <a-select
                style="width: 257px"
                v-model="branch_id"
                :options="branchs"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
          </div>
        </div>
        <div class="row">
          <ts-button class="btn-block" @click.prevent="clearFilter">
            <i class="far fa-times-circle"></i>
            {{ $t('studentprofile.clearFilter') }}
          </ts-button>
        </div>
      </a-drawer>
      <a-modal v-model="visibleCard" :width="300" @ok="previewCard('simple')">
        <div class="form-group m-b-15">
          <label>Print Date</label>
          <ts-date-picker-input v-model="print_date"> </ts-date-picker-input>
        </div>
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import DeleteComponent from './delete'
import PreviewCard from './preview-card'
import moment from 'moment'
export default {
  name: 'pickup-card-creation',
  data() {
    return {
      visible: false,
      visibleCard: false,
      loading: false,
      exporting: false,
      checkedGuardian: [],
      branchs: [],
      side: 'front',
      print_date: moment().format('DD-MM-YYYY'),
      manPhoto: require('../../assets/staff-default-man.png'),
      womenPhoto: require('../../assets/staff-default-women.png'),
      defaultPhoto: require('../../assets/user_default.png')
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('pickupCardCreation', ['resources', 'pagination']),
    columns() {
      return [
        {
          name: this.$t('pickupCardCreation.branch'),
          sortKey: 'branch.branch_name_en'
        },
        {
          name: this.$t('pickupCardCreation.photo')
        },
        {
          name: this.$t('pickupCardCreation.cardNumber'),
          sortKey: 'card_number',
          style: 'text-align:center'
        },
        {
          name: this.$t('pickupCardCreation.nameEn'),
          sortKey: 'guardian'
        },
        {
          name: this.$t('pickupCardCreation.nameKh'),
          sortKey: 'guardian_kh'
        },
        {
          name: this.$t('pickupCardCreation.relationship'),
          sortKey: 'relationship',
          style: 'text-align:center'
        },
        {
          name: this.$t('pickupCardCreation.phoneNumber'),
          style: 'text-align:center'
        },
        {
          name: this.$t('pickupCardCreation.issuedDate'),
          style: 'text-align:center'
        },
        {
          name: this.$t('pickupCardCreation.expiryDate'),
          style: 'text-align:center'
        },
        {
          name: 'Print Counter',
          style: 'text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center;width: 2%' }
      ]
    },
    search: {
      get() {
        return this.$store.state.pickupCardCreation.search
      },
      set(newValue) {
        this.$store.commit('pickupCardCreation/SET_SEARCH', newValue)
        this.$store.commit('pickupCardCreation/RESET_CURRENT_PAGE')
      }
    },
    is_print_card: {
      get() {
        return this.$store.state.pickupCardCreation.is_print_card
      },
      set(newValue) {
        this.$store.commit('pickupCardCreation/SET_IS_PRINT_CARD', newValue)
      }
    },
    branch_id: {
      get() {
        return this.$store.state.pickupCardCreation.branch_id
      },
      set(newValue) {
        this.$store.commit('pickupCardCreation/SET_BRANCH_ID', newValue)
      }
    }
  },
  methods: {
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'pickupCardCreation/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(errors => {
          this.loading = false
          this.$toasted.error(errors.message)
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    increase(record) {
      record._deleting = true
      this.$store
        .dispatch(
          'pickupCardCreation/increaseCounter',
          record.student_pickup_id
        )
        .then(() => {
          record.printer_counter = parseInt(record.printer_counter, 10) + 1
          this.loading = false
        })
        .catch(errors => {
          this.$toasted.error(errors.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    edit(record) {
      this.$store.commit('pickupCardCreation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'pickup-card-creation-edit',
        params: { id: record.student_pickup_id }
      })
    },
    showDeleteForm(data) {
      this.$modal.show(
        DeleteComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    previewCard(type) {
      this.visibleCard = false
      this.$modal.show(
        PreviewCard,
        {
          id_list: this.checkedGuardian,
          side: this.side,
          print_date: this.print_date,
          type: type
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    card(record, side) {
      this.checkedGuardian = []
      this.checkedGuardian.push(record.student_pickup_id)
      this.side = side
      if (side == 'back') {
        this.visibleCard = true
      } else {
        this.previewCard()
        this.checkedGuardian = []
      }
    },
    guardianPhoto(record) {
      if (record.photo) {
        return record.photo
      }
      if (record.relationship == 'Father') {
        return this.manPhoto
      }
      if (record.relationship == 'Mother') {
        return this.womenPhoto
      }
      if (record.relationship == 'Other') {
        return this.defaultPhoto
      }
    },

    onError(record) {
      event
        ? (event.target.src =
            record.relationship == 'Father' ? this.manPhoto : this.womenPhoto)
        : ''
    },
    checkItem(value) {
      this.checkedGuardian = []
      if (!_.isEmpty(value)) {
        value.forEach(el => {
          this.checkedGuardian.push(el.student_pickup_id)
        })
      }
    },
    clearFilter() {
      this.is_print_card = null
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({
        search,
        branch_id: this.branch_id
      })
    }, 500),
    is_print_card: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('pickupCardCreation/RESET_STATE')
    next()
  }
}
</script>
